import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
// import { buildThumbnailUrl, SanitizeHtml } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';

// import { colors } from '../styles';
// import { UnderdogLeft } from '../helpers/UIElements';

const styles = css`
padding: 20px 0;
background-color: #f3e4c8;
@media(min-width: 992px) {
  padding: 30px 0;
}
  .HomeAlert_btn {
    color: #ffffff;
  }
}
`;

function HomeAlert({ area, widget }) {
  const areaContent = get(widget, 'area[0]');
  return (
    <aside className={styles}>
      <div className="container">
        <div className="d-block d-lg-column">
          <span className="HomeAlert_titles"><b>Currently Unavailable</b></span>
          <p className="HomeAlert_subtitles">{`There are currently no available homes in ${get(area, 'name', get(areaContent, 'area_title'))}. Please contact us if you would like to be notified when there are homes available.`}</p>
          <a className="btn HomeAlert_btn" href="/contact-us">Contact Us</a>
        </div>
      </div>
    </aside>
  );
}

HomeAlert.propTypes = {
  area: PropTypes.object,
  widget: PropTypes.object.isRequired,
};

HomeAlert.defaultProps = {
  area: undefined,
};

export default withData(
  {
    area: true,
    widget: 'default_area',
  },
  {
    required: {
      widget: true,
    },
  },
)(HomeAlert);



// WEBPACK FOOTER //
// ./src/components/HomesAlert.js